var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 3.5V12.5C16.75 13.3438 16.0625 14 15.25 14H2.25C1.40625 14 0.75 13.3438 0.75 12.5V3.5C0.75 2.6875 1.40625 2 2.25 2H5L5.375 1C5.59375 0.40625 6.15625 0 6.78125 0H10.6875C11.3125 0 11.875 0.40625 12.0938 1L12.5 2H15.25C16.0625 2 16.75 2.6875 16.75 3.5ZM12.5 8C12.5 5.9375 10.8125 4.25 8.75 4.25C6.65625 4.25 5 5.9375 5 8C5 10.0938 6.65625 11.75 8.75 11.75C10.8125 11.75 12.5 10.0938 12.5 8ZM11.5 8C11.5 9.53125 10.25 10.75 8.75 10.75C7.21875 10.75 6 9.53125 6 8C6 6.5 7.21875 5.25 8.75 5.25C10.25 5.25 11.5 6.5 11.5 8Z",
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.e18ff70f1f62b3e22fcdd8bd270dc704.svg";
export { ForwardRef as ReactComponent };